// extracted by mini-css-extract-plugin
export default {"graphic":"Graphic_graphic__fuFbD","tspan":"Graphic_tspan__vindB"};